<template>

    <SubHeader :title="'Utilisateur: ' + (userShowItems.firstname ?? '') + ' ' + (userShowItems.lastname ?? '')"
        :breads="[{ name: 'Utilisateur' }]" :action="{ to: 'AdminUserProfileUser', title: 'Revernir sur la liste' }" />

    <Modal>


        <div class="" v-if="!isLoading">
            <span>Voulez-vous vraiment <b v-if="userStateIsDisabled" class="text-danger">Désactiver</b><b v-else
                    class="text-info">Activer</b> le compte de l'utilisateur <strong>{{
                        userShowItems?.firstname }}</strong>
            </span>

        </div>
        <div class="spinner-grow" role="status" v-else>
            <span class="visually-hidden">Loading...</span>
        </div>
        <template #btn>
            <span v-if="!isLoading">
                <button type="button" v-if="userStateIsDisabled" class="btn btn-danger"
                    @click="updateUserState(userShowItems?.id)">
                    Désactiver
                </button>
                <button type="button" v-else class="btn btn-info" @click="updateUserState(userShowItems?.id)">
                    Activer
                </button>
            </span>
            <div class="spinner-grow" role="status" v-else>
                <span class="visually-hidden">Loading...</span>
            </div>


        </template>
    </Modal>


    <div class="col-lg-12">
        <div class="">
            <div class="card-body">

                <!-- Profile Cover -->
                <div class="profile-cover">
                    <div class="profile-cover-img-wrapper">
                        <img class="profile-cover-img" src="@/assets/img/1920x400/img1.jpg" alt="Image Description">
                    </div>
                </div>
                <!-- End Profile Cover -->

                <!-- Profile Header -->
                <div class="text-center align-items-center justify-content-center d-flex  mb-5"
                    style="flex-direction: column">
                    <div class="avatar avatar-xxl avatar-circle profile-cover-avatar">
                        <img class="avatar-img" src="@/assets/img/img1.jpg" alt="Image Description">
                        <span
                            :class="!userShowItems?.status ? 'avatar-status avatar-status-danger' : 'avatar-status avatar-status-success'"></span>
                    </div>
                    <!-- End Avatar -->
                    <div class="spinner-grow" role="status" v-if="userShowIsLoading">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <template v-else>
                        <h1 class="page-header-title">{{ userShowItems.firstname ?? "" }} {{ userShowItems.lastname ??
                            "" }}
                        </h1>



                        <button v-if="userShowItems.status" class="badge bg-soft-danger text-danger "
                            @click="disabledUser(true)">
                            <span class="d-flex">
                                <i class="bi-trash"></i> Désactiver le compte
                            </span>

                        </button>
                        <button v-else class="badge bg-soft-success text-success " @click="disabledUser(false)">
                            <span class="d-flex">
                                <i class="bi-check"></i> Activer le compte
                            </span>

                        </button>


                    </template>


                    <!-- End List -->
                </div>
                <!-- End Profile Header -->


                <!-- End Nav -->

                <div class="tab-content" id="notificationTabContent">
                    <div class="tab-pane fade show active" id="notificationNavOne" role="tabpanel"
                        aria-labelledby="notificationNavOne-tab">
                        <div class="row">
                            <div class="col-lg-4">

                                <div id="accountSidebarNav"></div>

                                <!-- Card -->
                                <div class="card mb-3 mb-lg-5">
                                    <!-- Header -->
                                    <div class="card-header">
                                        <h4 class="card-header-title">Profile</h4>
                                    </div>
                                    <!-- End Header -->

                                    <!-- Body -->
                                    <div class="card-body">
                                        <ul class="list-unstyled list-py-2 text-dark mb-0">
                                            <li class="pb-0"><span class="card-subtitle">A propos </span></li>
                                            <li><i class="bi-person dropdown-item-icon"></i> {{ userShowItems.firstname
                                                ?? "" }}
                                                {{ userShowItems.lastname ?? "" }} </li>
                                            <li><i class="bi-at dropdown-item-icon"></i> {{ userShowItems.email ?? "" }}
                                            </li>

                                            <li class="pt-4 pb-0"><span class="card-subtitle">Roles</span></li>

                                            <li><i class="bi-building dropdown-item-icon"></i> <span
                                                    v-for="(role, i) in userShowItems.roles" :key="i"
                                                    class="badge bg-soft-primary text-dark ml-2 mr-2 ">{{ role.name
                                                    }}</span>
                                                <span class="text-primary " style="cursor:pointer"
                                                    v-if="!userShowItems?.roles?.length">+
                                                    Ajouter un role</span>
                                            </li>

                                            <li class="pt-4 pb-0"><span class="card-subtitle">Caracterisation
                                                    suivie</span></li>
                                            <i class="bi-stickies dropdown-item-icon"></i> <span
                                                v-for="(role, i) in userShowItems?.followed_characterizations" :key="i"
                                                class="badge bg-soft-primary text-dark " style="margin: 5px;">{{
                                                    role.name
                                                }}</span>
                                            <span class="text-primary " style="cursor:pointer"
                                                v-if="!userShowItems?.followed_characterizations?.length">+
                                                Suivre une caracterisation</span>
                                        </ul>
                                    </div>
                                    <!-- End Body -->
                                </div>
                                <div class="card">
                                    <!-- Header -->
                                    <div class="card-header card-header-content-between">
                                        <h4 class="card-header-title">Activites</h4>

                                        <!-- Dropdown -->
                                        <div class="dropdown">
                                            <button type="button"
                                                class="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                                                id="contentActivityStreamDropdown" data-bs-toggle="dropdown"
                                                aria-expanded="false">
                                                <i class="bi-three-dots-vertical"></i>
                                            </button>

                                            <div class="dropdown-menu dropdown-menu-end mt-1"
                                                aria-labelledby="contentActivityStreamDropdown">
                                                <span class="dropdown-header">Exportation</span>

                                                <a class="dropdown-item"
                                                    @click.prevent="exportUserActivite(this.$route.params.id ?? 0)">
                                                    <i class="bi bi-file-earmark-excel  dropdown-item-icon"></i> En
                                                    Excel
                                                </a>

                                            </div>
                                        </div>
                                        <!-- End Dropdown -->
                                    </div>
                                    <!-- End Header -->

                                    <!-- Body -->
                                    <div class="card-body card-body-height" style="height: 61rem;">
                                        <!-- Step -->
                                        <div v-if="userShowIsLoading" class=""
                                            style="min-height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                                            <div class="spinner-grow" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </div>

                                        <ul class="step step-icon-xs mb-0" v-else-if="userActiviteShowIsSuccess">
                                            <li class="step-item" v-for="(activity, i) in userActiviteShowItems"
                                                :key="i">
                                                <div class="step-content-wrapper">
                                                    <span class="step-icon step-icon-pseudo step-icon-soft-dark"></span>

                                                    <div class="step-content">
                                                        <h5 class="step-title">
                                                            <a class="text-dark" href="#">{{ activity.description }}</a>
                                                        </h5>

                                                        <div class="fs-5 mb-1">{{ activity.action }}
                                                            <div class=""> <a class="text-uppercase" href=""><i
                                                                        class="bi-cpu"></i>{{
                                                                            activity.ip }}</a><span
                                                                    class="badge bg-soft-success text-success rounded-pill"><span
                                                                        class="legend-indicator bg-success"></span>{{
                                                                            activity.response_status }}</span></div>
                                                        </div>

                                                        <div class="text-muted small">
                                                            {{ activity.referrer }}{{ activity.route }}</div>
                                                        <span class="text-muted small text-uppercase">{{
                                                            activity.created_at
                                                            }}</span>
                                                    </div>
                                                </div>
                                            </li>

                                        </ul>
                                    </div>
                                    <div class="card-footer">
                                        <b-pagination :limit="2" :keepLength="true"
                                            :data="userActiviteCurrentItems ?? {}"
                                            @pagination-change-page="getResults" />
                                    </div>
                                    <!-- End Footer -->
                                </div>
                                <!-- End Card -->
                            </div>

                            <div class="col-lg-8">
                                <div class="d-grid gap-3 gap-lg-5">
                                    <div class="row">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-header-title">Modifier profile</h4>
                                            </div>
                                            <div class="card-body">
                                                <form @submit.prevent="prepareBeforeSubmit">

                                                    <div class="mb-3">
                                                        <label class="form-label" for="user_lastname">Nom</label>
                                                        <input required type="text" name="user_lastname"
                                                            v-model="data.lastname" id="user_lastname"
                                                            class="form-control" placeholder="Nom">
                                                    </div>
                                                    <div class="mb-3">
                                                        <label class="form-label" for="user_firstname">Prénom(s)</label>
                                                        <input type="text" name="user_firstname"
                                                            v-model="data.firstname" id="user_firstname"
                                                            class="form-control" placeholder="Prénom(s)">
                                                    </div>
                                                    <div class="mb-3">
                                                        <label class="form-label" for="user_email">Email</label>
                                                        <input required type="text" name="user_email" id="user_email"
                                                            v-model="data.email" class="form-control"
                                                            placeholder="Email">
                                                    </div>

                                                    <div class="mb-3 tom-select-custom">
                                                        <label class="form-label" for="user_profile">Roles</label>

                                                        <m-select v-model="data.roles" :loading="profilIsLoading"
                                                            :multiple="true" :required="true" :options="profilItems"
                                                            :searchable="false" placeholder="Liste des roles"
                                                            track-by="id" label="name" :close-on-select="true">
                                                        </m-select>
                                                    </div>
                                                    <!-- <label class="row form-check form-switch mb-1"
                                                        for="accounrSettingsPreferencesSwitch2">
                                                        <span class="col-8 col-sm-9 ms-0">
                                                            <span class="d-block text-dark mb-1">S'agit-il d'un
                                                                utilisateur
                                                                d'une Administration de l'Etat ??</span>
                                                            <span class="d-block fs-5 text-muted"><a class="link" href="#">Quelle est la difference?</a>.</span> 
                                                        </span>
                                                        <span class="col-4 col-sm-3 text-end">
                                                            <span>Non</span>
                                                            <input type="checkbox" v-model="showInstitutionSelect"
                                                                class="form-check-input mx-1"
                                                                id="accounrSettingsPreferencesSwitch2" checked="">
                                                            <span>Oui</span>
                                                        </span>
                                                    </label> -->
                                                    <div class="mb-3 tom-select-custom" v-if="data.institution_id">
                                                        <label class="form-label" for="user_profile">Institution</label>
                                                    
                                                        <m-select v-model="data.institution"
                                                            :loading="institutionIsLoading" :required="true"
                                                            :options="institutionItems" :preselectFirst="true"
                                                            :searchable="false" placeholder="Liste des institutions"
                                                            track-by="id" label="label" :close-on-select="true">
                                                        </m-select>
                                                    </div>

                                                    <div class="justify-content-end d-flex">
                                                        <button class="btn btn-primary text-white" type="submit">
                                                            <span class="form-check-default">
                                                                <i class="bi-pencil mr-1"></i>Modifier
                                                            </span>
                                                        </button>
                                                    </div>

                                                </form>



                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-header-title">Modifier Mot de passe</h4>
                                            </div>
                                            <div class="card-body">
                                                <form @submit.prevent="handlePassword">



                                                    <div class="mb-3">
                                                        <div class="d-flex justify-content-between">
                                                            <label class="form-label" for="password">Nouveau Mot de
                                                                passe</label>
                                                            <span class="d-block fs-5 text-muted"><span class="link"
                                                                    @click="autoGeneratePassword">Auto
                                                                    Generate</span>.</span>

                                                        </div>

                                                        <input required :type="showPassword ? 'text' : 'password'"
                                                            name="password" id="password"  v-model="passwordForm.password"
                                                            class="form-control" placeholder="********">
                                                    </div>
                                                    <div class="mb-3">
                                                        <div class="d-flex justify-content-between">
                                                            <label class="form-label" for="password">Confirmer Mot de
                                                                passe</label>


                                                        </div>

                                                        <input required :type="showPassword ? 'text' : 'password'"
                                                            name="password" id="password" v-model="passwordForm.confirmPassword"
                                                            class="form-control" placeholder="********">
                                                    </div>




                                                    <div class="justify-content-end d-flex">
                                                        <button class="btn btn-primary text-white" type="submit">
                                                            <span class="form-check-default">
                                                                <i class="bi-pencil mr-1"></i>Modifier
                                                            </span>
                                                        </button>
                                                    </div>

                                                </form>



                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="card mb-3 mb-lg-5">
                                            <div class="card-header">
                                                <h4 class="card-header-title">Caractérisations</h4>
                                            </div>




                                            <form class="card-body"  @submit.prevent="handleCaracterisation">

                                                <div class="mb-3 tom-select-custom"
                                                    v-for="(categ, i) in caracterisationItems" :key="i">
                                                    <label v-if="categ.type != 'Zone de texte'" class="form-label"
                                                        :for="categ.name">{{ categ.name }}</label>
                                              
                                                    <m-select v-if="categ.type != 'Zone de texte' "
                                                        v-model="caracterisationForm[categ.id]"
                                                        :loading="caracterisationIsLoading" :options="categ.elements"
                                                        :searchable="true" :multiple="true"
                                                        :placeholder="'Liste des ' + categ.name" track-by="id"
                                                        label="name" :close-on-select="true">
                                                    </m-select>
                                                </div>
                                                <div class="justify-content-end d-flex">
                                                    <button class="btn btn-primary text-white" type="submit">
                                                        <span class="form-check-default">
                                                            <i class="bi-pencil mr-1"></i>Modifier
                                                        </span>
                                                    </button>
                                                </div>


                                            </form>

                                            <!-- End Body -->
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade show" id="notificationNavThree" role="tabpanel"
                        aria-labelledby="notificationNavThree-tab">
                        <div class="row">
                            <div class="col-lg-12">

                                <!-- End Card -->
                            </div>


                        </div>
                    </div>
                </div>

                <!-- End Row -->
            </div>

        </div>
    </div>


</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Modal from "@/widgets/Modal";
import notify from "@/utils/notify.js"
export default {
    name: "ShowUser",
    components: {
        SubHeader,
        Modal
    },
    data() {
        return {
            data: {
            },
            caracterisationForm: {},
            passwordForm: {
                password: "",
                confirmPassword: ""
            },
            cols: [
                { field: 'action', title: 'Action' },
                { field: 'description', title: 'Description' },
                { field: 'type', title: 'Type' },
                { field: 'navigateur', title: 'Navigateur' },
                { field: 'ip', title: 'Ip' },
                { field: 'referrer', title: 'Reference' },
            ],
            showPassword: false,
            searchWord: null,
            userStateIsDisabled: false,
            // showProfilSelect: false,
        }
    },
    computed: {
        ...mapFields("user/show", {
            userShowItems: "item",
            userShowCaracterisations: "caracterisations",
            userShowIsLoading: "isLoading",
            userShowIsSuccess: "isSuccess",
        }),
        ...mapFields("widget/modal", {
            toggleModal: "showMessage",
        }),
        ...mapFields("caracterisation/list", {
            caracterisationItems: "items",
            caracterisationIsLoading: "isLoading",
            caracterisationIsSuccess: "isSuccess",
        }),
        ...mapFields("user_activite/list", {
            userActiviteShowItems: "items",
            userActiviteShowIsLoading: "isLoading",
            userActiviteShowIsSuccess: "isSuccess",
            userActiviteCurrentItems: "currentItem",
        }),
        ...mapFields("institution/list", {
            institutionItems: "items",
            institutionIsLoading: "isLoading",
            institutionIsSuccess: "isSuccess",
        }),

        ...mapFields("user/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated: "isUpdated",
            item: "items",
        }),
        ...mapFields("profil/list", {
            profilIsLoading: "isLoading",
            profilIsSuccess: "isSuccess",
            profilShowMessage: "showMessage",
            profilMessage: "message",
            profilItems: "items"
        })


    },
    methods: {
        getResults(page) {
            this.getUserActivite(`${this.$route.params.id ?? 0}&page=${page}`)
        },
        ...mapActions({
            reset: "user/show/resetData",
            resetCaracterisation: "caracterisation/show/resetData",
            resetInstitution: "institution/list/resetData",
            resetProfil: "profil/show/resetData",
            handleSubmit: "user/update/update",
            updateUserState: "user/update/updateState",
            resetUser: "user/update/resetData",
            getUser: "user/show/getOne",
            getCaracterisations: "caracterisation/list/getAll",
            getInstitutions:"institution/list/getAll",
            getUserActivite: "user_activite/list/getAll",
            exportUserActivite: "user_activite/list/exportData",
            getProfils: "profil/list/getAll",
        }),
        autoGeneratePassword() {
            const passwordGenerate = Math.random().toString(36).slice(-8);
            this.passwordForm.password =passwordGenerate ;
            this.passwordForm.confirmPassword =passwordGenerate ;
            this.showPassword = true;
        },

        prepareBeforeSubmit() {
            const currentData = { ...this.data };

            delete currentData?.profil
            delete currentData?.institution

            currentData.roles = this.data?.roles?.map(({ id }) => id)

            this.handleSubmit(currentData);
        },
        handleCaracterisation() {
            
            const caracterisationKeys = {};
            const keys = Object.keys(this.caracterisationForm);
            if(this.caracterisationForm){

                keys.forEach((key)=>{
                    caracterisationKeys[key] = this.caracterisationForm[key].map(({id})=>id)
                    return false
                })
            }
            this.handleSubmit({id:this.userShowItems.id,firstname:this.userShowItems.firstname,lastname:this.userShowItems.lastname,email:this.userShowItems.email,roles:this.userShowItems.roles?.map(({ id }) => id),caracterisations:caracterisationKeys});
        },
        handlePassword() {
            
            if(this.passwordForm.confirmPassword !== this.passwordForm.password){
                notify("Mot de passe incorrect")
                return
            }
            this.handleSubmit({id:this.userShowItems.id,firstname:this.userShowItems.firstname,lastname:this.userShowItems.lastname,email:this.userShowItems.email,roles:this.userShowItems.roles?.map(({ id }) => id),password:this.passwordForm.confirmPassword});
        },
        disabledUser(isDisabled) {
            this.userStateIsDisabled = isDisabled;
            this.toggleModal = true
        }
    },

    mounted() {
        this.getUser(this.$route.params.id ?? 0)
        this.getCaracterisations()
        this.getProfils()
        this.getUserActivite(this.$route.params.id ?? 0)
        this.getInstitutions()

    },
    watch: {
        isUpdated(val) {
            if (val) {
                this.getUser(this.$route.params.id ?? 0)

                this.toggleModal = false
                notify("Utilisateur modifié avec success", "success")
            }
        },
        userShowItems(val) {
            if (val) {
                this.data = { ...this.userShowItems };
                this.caracterisationForm = { ...this.userShowCaracterisations };


            }
        }

    },
    unmounted() {
        this.resetUser()
        this.resetProfil()
        this.resetCaracterisation()
        this.resetInstitution()
    }
}
</script>
